var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandJbcorp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 47,
    viewBox: "0 0 200 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_628_8490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.12 42.5604C121.623 42.5604 118.886 39.7017 118.886 36.0523C118.886 32.4028 121.623 29.5745 125.12 29.5745C126.878 29.5745 128.326 30.1645 129.354 31.2594C130.771 32.7678 132.893 33.3821 134.907 32.9077C133.861 28.6318 129.98 25.7913 125.12 25.7913C119.263 25.7913 114.677 30.2983 114.677 36.0523C114.677 41.8062 119.263 46.3132 125.12 46.3132C130.199 46.3132 133.927 43.4971 134.943 38.9353H134.895C132.912 38.5339 130.795 39.1238 129.481 40.6627C128.435 41.8913 126.939 42.5604 125.12 42.5604Z",
    fill: "#0F206C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.44 25.7913C142.564 25.7913 137.966 30.3105 137.966 36.0827C137.966 41.8548 142.564 46.3132 148.44 46.3132C154.316 46.3132 158.914 41.8183 158.914 36.0827C158.914 30.347 154.316 25.7913 148.44 25.7913ZM148.44 42.53C144.87 42.53 142.175 39.7564 142.175 36.0827C142.175 32.4089 144.87 29.5745 148.44 29.5745C152.01 29.5745 154.705 32.3724 154.705 36.0827C154.705 39.7929 152.01 42.53 148.44 42.53Z",
    fill: "#0F206C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.381 38.6068C177.538 37.9074 179.423 35.6265 179.423 32.5123C179.423 28.7048 176.699 26.2475 172.484 26.2475H162.557V45.8509H166.766V38.838H168.828L174.989 45.8509H179.959L173.7 38.7528L174.381 38.6008V38.6068ZM166.772 35.4562V29.7266H171.936C173.949 29.7266 175.306 30.8701 175.306 32.5731C175.306 34.2762 173.955 35.4562 171.936 35.4562H166.772Z",
    fill: "#0F206C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.908 26.2475H183.255V45.8509H187.464V39.5982H192.689C197.123 39.5982 199.994 36.9585 199.994 32.8712C199.994 28.7838 197.208 26.2414 192.902 26.2414L192.908 26.2475ZM192.33 36.2165H187.47V29.7266H192.33C194.453 29.7266 195.882 31.016 195.882 32.9441C195.882 34.8723 194.489 36.2225 192.33 36.2225V36.2165Z",
    fill: "#0F206C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.515 23.4375V35.6387C74.515 38.6069 72.5139 40.681 69.6492 40.681C66.9729 40.681 65.2273 39.1056 64.7346 36.2408L64.6738 35.8941L58.1353 37.2018L58.1961 37.5364C59.2787 43.2416 63.5607 46.6538 69.6431 46.6538C76.5952 46.6538 81.2725 42.2259 81.2725 35.6448V17.0267H80.9319C77.392 17.0267 74.515 19.9036 74.515 23.4436V23.4375Z",
    fill: "#0F206C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.251 37.5486C109.227 36.5085 108.996 35.5414 108.57 34.6716C108.546 34.6169 108.515 34.5682 108.491 34.5195L108.4 34.3492C108.363 34.2763 108.327 34.2093 108.29 34.1485C108.047 33.7471 107.749 33.3639 107.408 33.0233L107.311 32.926C107.256 32.8773 107.202 32.8287 107.153 32.7861C106.192 31.9041 105.121 31.3993 104.392 31.1317C104.969 30.8154 105.76 30.2984 106.49 29.5807C107.086 29.0515 107.56 28.3885 107.895 27.6222C108.084 27.2146 108.217 26.7828 108.309 26.2962L108.339 26.1502C108.412 25.7245 108.448 25.2744 108.448 24.8304C108.448 20.0922 105.17 17.0328 100.097 17.0328H85.6518V46.003H100.14C105.791 46.003 109.184 43.0653 109.251 38.1264H109.264L109.251 37.5546V37.5486ZM92.1539 33.6802H99.0391C101.18 33.6802 102.622 35.0548 102.622 37.0985C102.622 39.3185 101.235 40.6445 98.9114 40.6445H92.1539V33.6802ZM98.4856 29.2097H92.1539V22.3792H98.7411C100.718 22.3792 102.153 23.7599 102.153 25.6636C102.153 27.7864 100.681 29.2097 98.4856 29.2097Z",
    fill: "#0F206C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000106812 25.4568V39.2455L11.8607 46.3132L11.8364 32.5123L0.000106812 25.4568Z",
    fill: "url(#paint0_linear_628_8490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3052 0.476562L12.5358 7.62333V46.3132L24.3052 39.2577V39.0813V0.476562Z",
    fill: "url(#paint1_linear_628_8490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9499 0.476562V24.1491L36.8348 31.4905V7.62333L24.9499 0.476562Z",
    fill: "url(#paint2_linear_628_8490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4005 32.5123L25.8015 39.4036L37.4005 46.3132L49.182 39.2516L37.4005 32.5123Z",
    fill: "url(#paint3_linear_628_8490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7776 31.9406V31.9466L49.5591 38.6859L49.5774 38.6737V24.9215V24.8911L37.7776 31.9406Z",
    fill: "url(#paint4_linear_628_8490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4552 17.3672V31.3019V31.3506V31.3932V31.454L49.255 24.4045L37.4552 17.3672Z",
    fill: "url(#paint5_linear_628_8490)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_628_8490",
    x1: -7.97994,
    y1: 26.436,
    x2: 11.9459,
    y2: 39.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0696CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_628_8490",
    x1: 20.1388,
    y1: 41.6237,
    x2: 17.1098,
    y2: 9.52102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4d515aCB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016DB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_628_8490",
    x1: 27.8086,
    y1: 30.5842,
    x2: 33.1429,
    y2: 5.31204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3DB5B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0696CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_628_8490",
    x1: 34.5175,
    y1: 41.6724,
    x2: 41.9684,
    y2: 35.8029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0696CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_628_8490",
    x1: 45.3197,
    y1: 28.7352,
    x2: 43.5923,
    y2: 35.6569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016DB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_628_8490",
    x1: 51.5663,
    y1: 7.19755,
    x2: 45.563,
    y2: 17.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016DB4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_628_8490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 46.1772,
    fill: "white",
    transform: "translate(0.000106812 0.476562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandJbcorp);
export default __webpack_public_path__ + "static/media/brand-jbcorp.68f8eabeba6f574539e992cccfcbaefc.svg";
export { ForwardRef as ReactComponent };